"use client"

import { useState, useCallback } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import RoleList from "./role-list"
import RoleModal from "./role-modal"
import RoleDetailModal from "./role-detail-modal"
import type { Role } from "./types"

const RoleContainer = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [detailModalOpen, setDetailModalOpen] = useState(false)
  const [selectedRole, setSelectedRole] = useState<Role | null>(null)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleOpenAdd = useCallback(() => {
    setSelectedRole(null)
    setModalOpen(true)
  }, [])

  const handleOpenEdit = useCallback((role: Role) => {
    setSelectedRole(role)
    setModalOpen(true)
  }, [])

  const handleOpenView = useCallback((role: Role) => {
    setSelectedRole(role)
    setDetailModalOpen(true)
  }, [])

  const handleSuccess = useCallback(() => {
    setModalOpen(false)
    setDetailModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }, [])

  const handleCloseModal = useCallback(() => {
    setModalOpen(false)
    setSelectedRole(null)
  }, [])

  const handleCloseDetailModal = useCallback(() => {
    setDetailModalOpen(false)
    setSelectedRole(null)
  }, [])

  return (
    <>
      <Breadcrumbs mainTitle="Role Management" parent="Administration" />
      <Container fluid>
        <Row>
          <Col md="12">
            <RoleList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              onView={handleOpenView}
              refreshTrigger={refreshTrigger}
            />
          </Col>
        </Row>

        {/* Role Create/Edit Modal */}
        <RoleModal isOpen={modalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} initialData={selectedRole} />

        {/* Role Detail Modal - Remove onSuccess prop since it doesn't exist */}
        <RoleDetailModal isOpen={detailModalOpen} onClose={handleCloseDetailModal} role={selectedRole} />
      </Container>
    </>
  )
}

export default RoleContainer
